const { String } = require('../../String/String')

/**
 * Visszaadja az aktuális időt.
 * @param {string | number} tmp - A paraméter, amiből az idő rész kell.
 * @example
 * '2021-01-01T12:34:56.789Z' => '12:34:56'
 * @returns {string} Az ISO idő: hh:ii:ss.
 */
module.exports.getTime = function getTime (tmp = Date.now()) {
  const today = new Date(tmp)

  const time = [
    String.pad(today.getHours()),
    String.pad(today.getMinutes()),
    String.pad(today.getSeconds())
  ].join(':')

  return time
}
